import {
  Component,
  OnInit,
  ViewChild,
  EventEmitter,
  Output,
  NgZone
} from '@angular/core';
import { MainPageService } from './../../../main-page.service';
import { Router } from '@angular/router';
import { CrossSectionModel } from '../../../../models/parts/cross-section.model';
import { mockedPicture } from './mock-picture-base64';
import { mockedStepFile } from './mock-step-file-base64';
import { SystemModel } from '../../../../models/dictionaries/system.model';
import { ShowViewerArgs } from '../../../../models/viewer/ShowViewerArgs.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';


@Component({
  selector: 'app-cross-section-managment',
  template: `<div *ngIf="crossSectionData !== undefined">
    <div class="row" style="padding-left: 12px;">
        <b>Cross Section:</b> &nbsp;{{crossSectionData.name}}</div>
    <div class="row" style="margin: 10px;">
        <!-- <button class="gray-button" (click)="openGraphicalTool()" [disabled]="!canOpenGraphicalTool">Open graphical tool</button> -->
        <button class="gray-button" data-toggle="modal" data-target="#editModal">Edit</button>
        <!-- <button class="gray-button" >Drawing/Pictures</button> -->
        <button class="gray-button" data-toggle="modal" data-target="#uploadModal">Upload file</button>
        <button class="gray-button" data-toggle="modal" data-target="#deleteModal">Delete</button>
    </div>
    <div class="row">
        <div class="col-6" style="line-height: 30px;">
            <div class="d-inline">Name:
            </div>
            <div class="d-inline">{{crossSectionData.name}}
                <br>
            </div>
            <div class="d-inline">Description:
            </div>
            <div class="d-inline">{{crossSectionData.description}}
                <br>
            </div>
            <div class="d-inline">System:
            </div>
            <div class="d-inline">{{crossSectionData.system}}
                <br>
            </div>
            <div class="d-inline">DUENQ Name:
            </div>
            <div class="d-inline">{{crossSectionData.duenqName}}
                <br>
            </div>
        </div>
        <div class="col-6">
            <div class="row">
                <div id="regularPictureDiv" [hidden]="!isPngVisible">
                    <div class="row">
                        <img height=150 width=150 [src]="pictureData" id="regularPicture">
                    </div>
                    <div class="row">
                        <label style="font-size:12px">Main picture</label>
                        <button style="font-size:12px;height:23px;margin-left: 3px;" (click)="deletePicture()">x</button>
                    </div>
                </div>

                <div id="stpFileDiv" [hidden]="!isStpVisible">
                    <div class="step-file">STEP FILE</div>
                    <div class="row">
                        <img height=150 width=150 src="https://www.freeviewer.org/img/stp/overview-stp.png" id="stpPicture">
                    </div>
                    <div class="row" style="margin-top: 10px; margin-left: 10px;">
                        <button class="configure-button" style="font-size:12px;height:23px;margin-left: 3px;" (click)="openGraphicalTool()" [disabled]="!canOpenGraphicalTool">
                            Configure
                        </button>
                        <button class="delete-button" style="font-size:12px;height:23px;margin-left: 3px;" (click)="deleteStepFile()">x</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Upload Modal -->
<div class="modal" id="uploadModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <div>
                    Select file:
                    <br/>
                    <input #fileUploadInput type="file" accept=".jpg,.jpeg,.png,.step,.stp">
                </div>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-danger save-button" data-dismiss="modal" (click)="upload()">Upload</button>
            </div>

        </div>
    </div>
</div>

<!-- Edit Modal -->
<div class="modal" id="editModal">
    <div class="modal-dialog">
        <div class="form">
            <form class="form-group" [formGroup]="formGroup">
                <div class="modal-content">

                    <!-- Modal Header -->
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body display-flex">
                        <div>
                            <div>
                                <div class="display-flex">
                                    <span class="modal-label">Name:</span>
                                    <input type="text" [(ngModel)]="editedCrossSection.name" formControlName="name">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Description:</span>
                                    <input type="text" [(ngModel)]="editedCrossSection.description" formControlName="description">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">System:</span>
                                    <select name="systemSelect" class="selectHeight" [(ngModel)]="editedCrossSection.system" formControlName="system">
                                        <option *ngFor="let system of systemsArray | sortByName" [ngValue]="system.name">{{system.name}}</option>
                                    </select>
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">DUENQ Name:</span>
                                    <input type="text" [(ngModel)]="editedCrossSection.duenqName" formControlName="duenqName" maxlength="50">
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                        <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="formGroup.invalid" (click)="save()">Save</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Delete Modal -->
<div class="modal" id="deleteModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <span class="modal-label">Do you want to delete this cross section?</span>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary" data-dismiss="modal" (click)="deleteCrossSection()">Delete</button>
            </div>
        </div>
    </div>
</div>`,
  styles: [`.regularObjectBorder{border-width:1px;border-style:solid}.justTopBorder{border-bottom:0;border-left:0;border-right:0}.justRightBorder{border-bottom:0;border-left:0;border-top:0}.justBottomBorder{border-right:0;border-left:0;border-top:0}#tabContent{font-size:11px}.modal-label{width:168px}.display-flex{display:flex;align-items:center;margin-bottom:10px}hr{margin-top:0}#variantsGrid{margin-left:17px}.step-file{font-size:14px;text-align:center;margin-bottom:10px;font-weight:700}.configure-button{height:23px;margin-left:3px;background-color:#4a8bb7;color:#fff;font-size:12px;padding:3px 14px;font-weight:300;letter-spacing:1.1px;box-shadow:0 2px 10px 0 rgba(0,0,0,.06);font-family:Roboto,sans-serif;text-transform:uppercase;outline:0;border:none;margin-bottom:6px;border-radius:2px;cursor:pointer}.configure-button:disabled{background-color:#999;cursor:default}.delete-button{height:23px;width:23px;margin-left:3px;background-color:#d0021b;color:#fff;font-size:12px;box-shadow:0 2px 10px 0 rgba(0,0,0,.06);font-family:Roboto,sans-serif;text-transform:uppercase;outline:0;border:none;border-radius:2px;cursor:pointer}`]
})
export class CrossSectionManagmentComponent implements OnInit {
  @ViewChild('fileUploadInput') fileInput;
  @Output() onShowViewer: EventEmitter<ShowViewerArgs> = new EventEmitter();

  public crossSectionData: any;
  public editedCrossSection = new CrossSectionModel();
  public showPicture = false;
  public canOpenGraphicalTool = false;
  private stpConvertTaskId: string;
  public mockedPictureBase64 = mockedPicture;
  public mockedStepFileBase64 = mockedStepFile;
  public isStpVisible = false;
  public isPngVisible = false;
  public pictureData: string;
  systemsArray: SystemModel[] = [];
  public formGroup: FormGroup;

  constructor(private mainPageService: MainPageService, private zone: NgZone) {}

  public ngOnInit(): void {
    this.loadData();
    this.createForm();
   }

   loadData(): void {
    this.mainPageService.loadAllSystems().subscribe((response) => {
      this.systemsArray = response;
    });
   }

  showCrossSection(sender) {
    this.crossSectionData = sender;
    this.editedCrossSection = {
      ...this.crossSectionData
    };
    this.setFilesData(sender);
    this.canOpenGraphicalTool = sender.isProtoConverted === true;
  }

  upload(): void {
    this.readThis(this.fileInput.nativeElement.files[0]);
  }

  readThis(inputFile: any): void {
    const file: File = inputFile;
    const myReader: FileReader = new FileReader();
    const scope = this;
    myReader.onloadend = function() {
      if (file.name.includes('.stp') || file.name.includes('.step')) {
        scope.isStpVisible = true;
        scope.sendSTPFile(myReader.result, scope.crossSectionData._id);
      } else {
        scope.zone.run(() => scope.pictureData = myReader.result);
        scope.isPngVisible = true;
        scope.sendPictureFile(myReader.result, scope.crossSectionData._id);
      }
    };
    myReader.readAsDataURL(file);
  }

  checkIfStpIsConverted(): void {
    const self = this;
    setTimeout(() => {
      self.mainPageService.checkTaskStatus(self.stpConvertTaskId)
      .subscribe((resp) => {
        if (resp.isFinished === true) {
          self.zone.run(() => self.canOpenGraphicalTool = resp.result);
          //self.canOpenGraphicalTool = resp.result;
        } else {
          self.checkIfStpIsConverted();
        }
      });
    }, 2000);
  }
  sendSTPFile(file, id): void {
    this.canOpenGraphicalTool = false;
    this.mainPageService.sentSTPFileForCrossSections(file, id)
        .subscribe((response) => {
          this.crossSectionData.stepFile = response.fileId;
          this.stpConvertTaskId = response.id;
          console.log(response);
          this.checkIfStpIsConverted();
        },
        (error: any) => {
          console.log(error);
        }
      );
  }
  sendPictureFile(picture, id) :void {
    this.mainPageService.sendPicture(picture, id)
        .subscribe((response) => {
          this.crossSectionData.picture = response.fileId;
        },
        (error: any) => {
          console.log(error);
        }
      );
  }

  openGraphicalTool(): void {
    this.onShowViewer.emit(new ShowViewerArgs(true, this.crossSectionData._id, 'CROSS_SECTION', null));
    //this.router.navigate(['/stp-configure']);
  }

  save(): void {
    Object.assign(this.crossSectionData, this.editedCrossSection);
    // this.mainPageService.mysubject.next(this.crossSectionData._id);
    
    this.mainPageService.updateCrossSectionInDb(JSON.stringify(this.crossSectionData)).subscribe(() => { });
  }

  deletePicture() {
    this.pictureData = '';
    this.isPngVisible = false;
    this.mainPageService.deleteFile(this.crossSectionData.picture).subscribe(() => {
    },
      () => {
      }
    );
    this.crossSectionData.picture = null;
  }

  deleteStepFile() {
    this.isStpVisible = false;
    this.mainPageService.deleteFile(this.crossSectionData.stepFile).subscribe(() => {
    },
      () => {
      }
    );
    this.crossSectionData.stepFile = null;
  }

  setFilesData(crossSection) {
    if(crossSection.picture !== undefined && crossSection.picture !== null && crossSection.picture !== "") {
      this.isPngVisible = true;
      this.mainPageService.getPicture(crossSection.picture).subscribe((res) => {
          this.pictureData = res.src;
        },
        (error: any) => {
          console.log(error);
        }
      );
    } else {
      this.pictureData = '';
      this.isPngVisible = false;
    }

    if(crossSection.stepFile !== undefined && crossSection.stepFile !== null && crossSection.stepFile !== "") {
      this.isStpVisible = true;
    } else {
      this.isStpVisible = false;
    }
  }

  deleteCrossSection() {
    this.mainPageService.removeCrossSection(this.crossSectionData._id).subscribe(() => { }, () => { });
    this.mainPageService.deleteCrossSectionSubject.next(this.crossSectionData._id);
  }

  private createForm() {
    this.formGroup = new FormGroup({
      name: new FormControl(this.editedCrossSection.name, Validators.required),
      description: new FormControl(this.editedCrossSection.description),
      system: new FormControl(this.editedCrossSection.system, Validators.required),
      duenqName: new FormControl(this.editedCrossSection.duenqName, Validators.maxLength(50)),
    });
  }
}
